var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationThumbdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#ED9200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,22) scale(1,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9219 11.7266C16.0156 12.2656 15.9453 12.7812 15.7109 13.2031C15.7812 13.7656 15.6172 14.3516 15.2891 14.7734C15.2656 16.0859 14.4688 17 12.6641 17C12.5 17 12.3125 17 12.125 17C9.73438 17 9.00781 16.1094 7.95312 16.0859C7.88281 16.3906 7.57812 16.625 7.25 16.625H5.75C5.32812 16.625 5 16.2969 5 15.875V10.25C5 9.85156 5.32812 9.5 5.75 9.5H8.04688C8.49219 9.125 9.125 8.09375 9.66406 7.55469C9.99219 7.22656 9.89844 5 11.3516 5C12.6875 5 13.5781 5.75 13.5781 7.46094C13.5781 7.90625 13.4844 8.25781 13.3672 8.5625H14.2344C15.3594 8.5625 16.25 9.52344 16.25 10.5547C16.25 11 16.1328 11.375 15.9219 11.7266ZM14.4688 12.9922C14.9844 12.5234 14.9141 11.7969 14.5859 11.4453C14.8203 11.4453 15.125 11 15.125 10.5781C15.1016 10.1328 14.7266 9.6875 14.2344 9.6875H11.7969C11.7969 8.79688 12.4531 8.375 12.4531 7.46094C12.4531 6.89844 12.4531 6.125 11.3516 6.125C10.9062 6.57031 11.1172 7.69531 10.4609 8.35156C9.82812 8.98438 8.91406 10.625 8.23438 10.625H8V15.0078C9.24219 15.0078 10.3438 15.875 12.0078 15.875H12.8984C13.7188 15.875 14.3281 15.4766 14.1406 14.3516C14.4922 14.1406 14.7734 13.4844 14.4688 12.9922ZM7.0625 15.125C7.0625 14.8203 6.80469 14.5625 6.5 14.5625C6.17188 14.5625 5.9375 14.8203 5.9375 15.125C5.9375 15.4531 6.17188 15.6875 6.5 15.6875C6.80469 15.6875 7.0625 15.4531 7.0625 15.125Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationThumbdownIcon);
export default __webpack_public_path__ + "static/media/notification-thumbdown-icon.c71de4ca25488f9176ff193e33d9d9b0.svg";
export { ForwardRef as ReactComponent };